import React from 'react';
import vcard  from "../json/vcard.json";

import squarepaw from "../images/square-paw.png";

function Vcard() {
    return (
        <div className="container">
            <header>
            <h1 className="title has-text-centered has-text-white">Welcome</h1>
            </header>
            <div className="columns is-centered">
                <div className="card column is-one-quarter">
                    <div className="card-image has-text-centered">
                        <figure className="image is-128x128 is-inline-block">
                            <img src={squarepaw} className="is-rounded clip-circle" alt="" />
                        </figure>
                    </div>
                    <div className="card-content hcard vcard">
                        <p className="p-name">{ vcard.firstName } { vcard.lastName }</p>
                        <p className="p-job-title">{ vcard.title }</p>
                        <p className="p-adr h-adr">
                            <span className="p-street-address">{ vcard.homeAddress.street }</span><br />
                            <span className="p-postal-code">{ vcard.homeAddress.postalCode }</span>&nbsp;
                            <span className="p-locality">{ vcard.homeAddress.city }</span><br />
                            <span className="p-country-name">{ vcard.homeAddress.countryRegion }</span>
                        </p>
                        <p>
                            { vcard.note }
                        </p>
                        <p>
                            <span className="u-url">www.dimarchi.net</span>
                        </p>
                        <p className="content has-text-centered">
                            <button className="button u-url mx-1 my-1"><a href={ vcard.socialUrls.LinkedIn }  title="My LinkedIn address, opens in a new window or tab" target="_blank" rel="noopener noreferrer">LinkedIn</a></button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Vcard;